"use strict";

require("core-js/modules/es7.promise.finally");

require("core-js/modules/es6.date.now");

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

var _regeneratorRuntime = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.object.assign");

var _classCallCheck = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CacheService = exports.DEFAULT_OPTIONS = void 0;

var feature_1 = require("../log/feature");
/** The default cache service options. */


exports.DEFAULT_OPTIONS = {};
var ORIGIN = 'CacheService';
/**
 * Manages short-term, or ephemeral data points.
 * @remarks
 * This service is meant to speed up your application, and should only be used when performance
 * can benefit from caching data. Generally, the usage of a cache service adds an unnecessary
 * layer of complexity, so avoid using it unless the application's performance demands it.
 */

var CacheService = /*#__PURE__*/function () {
  function CacheService(options, root) {
    _classCallCheck(this, CacheService);

    this.root = root;
    this.options = Object.assign(Object.assign({}, exports.DEFAULT_OPTIONS), options);
  }

  _createClass(CacheService, [{
    key: "_getSpanContext",
    value: function _getSpanContext() {
      return {
        origin: ORIGIN,
        tags: {
          'cache.store': this.getStore()
        }
      };
    }
    /**
     * Gets an item from the cache.
     * @param key - the key to get
     * @returns a promise resolving to the value of the key, or null if it's not found.
     */

  }, {
    key: "get",
    value: function get(key) {
      var _this = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.get_item',
        name: key
      }), function () {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", this._get(key));

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      });
    }
  }, {
    key: "put",
    value: function put(key, value, secondsOrOpts) {
      var _this2 = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.save',
        name: key,
        data: {
          secondsOrOpts: secondsOrOpts
        }
      }), function () {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(typeof secondsOrOpts === 'number')) {
                    _context2.next = 4;
                    break;
                  }

                  return _context2.abrupt("return", this._put(key, value, secondsOrOpts));

                case 4:
                  return _context2.abrupt("return", this._put(key, value, secondsOrOpts));

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));
      });
    }
    /**
     * Stores a key in the cache, optionally with an expiration. Records the key
     * inside the specified buckets. Use {@link deleteBucket} to delete all of the
     * keys in the bucket later.
     *
     * @param key - the key to store
     * @param value - the value of the key
     * @param seconds - the seconds before the key expires
     * @param buckets - the keys of the buckets to add the key to
     * @returns a boolean indicating whether or not the key was stored
     */

  }, {
    key: "putWithBuckets",
    value: function putWithBuckets(key, value, seconds, buckets) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this3 = this;

        var putResult;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.put(key, value, seconds);

              case 2:
                putResult = _context4.sent;

                if (!(buckets === null || buckets === void 0 ? void 0 : buckets.length)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 6;
                return Promise.all(buckets.map(function (bucket) {
                  return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            (0, feature_1.debug)('recording key %s in bucket %s', key, bucket);
                            _context3.next = 3;
                            return this.setAdd(bucket, [key], seconds);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));
                }));

              case 6:
                return _context4.abrupt("return", putResult);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /**
     * Adds the passed item to a set in the cache.
     * @param key the name of the set
     * @param values the values to add to the set
     * @param seconds the seconds before the entire set expires
     * @returns a promise resolving to the number of items actually added to the set
     */

  }, {
    key: "setAdd",
    value: function setAdd(key, values, seconds) {
      var _this4 = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.save',
        name: "SetAdd ".concat(key),
        data: {
          seconds: seconds
        }
      }), function () {
        return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", this._setAdd(key, values, seconds));

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));
      });
    }
    /**
     * Removes the passed item from a set in the cache.
     * @param key the name of the set
     * @param values the values to remove from the set
     * @returns a promise resolving to the number of items actually removed from the set
     */

  }, {
    key: "setRemove",
    value: function setRemove(key, values) {
      var _this5 = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.save',
        name: "SetRemove ".concat(key)
      }), function () {
        return __awaiter(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  return _context6.abrupt("return", this._setRemove(key, values));

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
      });
    }
    /**
     * Gets all members of an existing set.
     * @param key the name of the set
     */

  }, {
    key: "setMembers",
    value: function setMembers(key) {
      var _this6 = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.get_item',
        name: "SetMembers ".concat(key)
      }), function () {
        return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt("return", this._setMembers(key));

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
      });
    }
    /**
     * Determines if the set has the specified member.
     * @param key the name of the set
     * @param value the value to check for
     */

  }, {
    key: "setHas",
    value: function setHas(key, value) {
      var _this7 = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.get_item',
        name: "SetHas ".concat(key)
      }), function () {
        return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  return _context8.abrupt("return", this._setHas(key, value));

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
      });
    }
    /**
     * Deletes a key from the cache.
     * @param keys - the keys to delete
     */

  }, {
    key: "delete",
    value: function _delete(keys) {
      var _this8 = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.delete_item',
        name: keys.length > 5 ? "[".concat(keys.length, " keys]") : keys.join(', '),
        data: {
          keys: keys
        }
      }), function () {
        return __awaiter(_this8, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  return _context9.abrupt("return", this._delete(keys));

                case 1:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));
      });
    }
    /**
     * Gets all keys inside a bucket, and deletes them (including the bucket).
     * @param buckets - the buckets to delete
     */

  }, {
    key: "deleteBuckets",
    value: function deleteBuckets(buckets) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this9 = this;

        var toDelete;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                (0, feature_1.debug)('deleting keys in buckets %O', buckets);
                toDelete = new Set();
                _context11.next = 4;
                return Promise.all(buckets.map(function (bucket) {
                  return __awaiter(_this9, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                    var keysInBucket, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

                    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.next = 2;
                            return this.setMembers(bucket);

                          case 2:
                            keysInBucket = _context10.sent;

                            if (!(keysInBucket === null || keysInBucket === void 0 ? void 0 : keysInBucket.length)) {
                              _context10.next = 23;
                              break;
                            }

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context10.prev = 7;

                            for (_iterator = keysInBucket[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                              key = _step.value;
                              toDelete.add(key);
                            }

                            _context10.next = 15;
                            break;

                          case 11:
                            _context10.prev = 11;
                            _context10.t0 = _context10["catch"](7);
                            _didIteratorError = true;
                            _iteratorError = _context10.t0;

                          case 15:
                            _context10.prev = 15;
                            _context10.prev = 16;

                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                              _iterator["return"]();
                            }

                          case 18:
                            _context10.prev = 18;

                            if (!_didIteratorError) {
                              _context10.next = 21;
                              break;
                            }

                            throw _iteratorError;

                          case 21:
                            return _context10.finish(18);

                          case 22:
                            return _context10.finish(15);

                          case 23:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10, this, [[7, 11, 15, 23], [16,, 18, 22]]);
                  }));
                }));

              case 4:
                _context11.next = 6;
                return this["delete"]([].concat(_toConsumableArray(toDelete), _toConsumableArray(buckets)));

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
    /**
     * Gets multiple keys from the cache in a performant manner.
     * @remarks
     * If you are calling {@link get} for several keys at once, use this method instead.
     * @param keys - the keys to get
     * @returns a promise resolving to the keys and their values
     */

  }, {
    key: "batchGetKeys",
    value: function batchGetKeys(keys) {
      var _this10 = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.get_item',
        name: keys.length > 5 ? "[".concat(keys.length, " keys]") : keys.join(', '),
        data: {
          keys: keys
        }
      }), function () {
        return __awaiter(_this10, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  return _context12.abrupt("return", this._batchGetKeys(keys));

                case 1:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, this);
        }));
      });
    }
    /**
     * Clears the cache.
     */

  }, {
    key: "clear",
    value: function clear() {
      var _this11 = this;

      return this.root.deps.services.error.span(Object.assign(Object.assign({}, this._getSpanContext()), {
        op: 'cache.clear',
        name: 'clear cache'
      }), function () {
        return __awaiter(_this11, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  return _context13.abrupt("return", this._clear());

                case 1:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));
      });
    }
  }, {
    key: "_acquireLock",
    value: function _acquireLock(key, timeout, retryDelay, onLockAcquired) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var self, retry, lockTimeoutValue, result;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                retry = function _ref() {
                  setTimeout(function () {
                    self._acquireLock(key, timeout, retryDelay, onLockAcquired);
                  }, retryDelay);
                };

                self = this;
                _context14.prev = 2;
                lockTimeoutValue = Date.now() + timeout + 1;
                _context14.next = 6;
                return this.put(key, lockTimeoutValue, {
                  ifNotExists: true,
                  seconds: timeout / 1000
                });

              case 6:
                result = _context14.sent;

                if (result) {
                  _context14.next = 9;
                  break;
                }

                throw new Error('Lock failed');

              case 9:
                onLockAcquired(lockTimeoutValue);
                _context14.next = 15;
                break;

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14["catch"](2);
                retry();

              case 15:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[2, 12]]);
      }));
    }
    /**
     * Creates a lock based on the cache service.
     * @param name the name of the lock
     * @param opts options to use when creating the lock
     * @returns A promise, resolving to a callback to call when you are done working with the lock.
     * @remarks From: https://github.com/errorception/redis-lock/blob/master/index.js
     */

  }, {
    key: "lock",
    value: function lock(name) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var _this12 = this;

        var _opts$timeout, timeout, _opts$retryDelay, retryDelay;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _opts$timeout = opts.timeout, timeout = _opts$timeout === void 0 ? 5000 : _opts$timeout, _opts$retryDelay = opts.retryDelay, retryDelay = _opts$retryDelay === void 0 ? 50 : _opts$retryDelay;
                return _context16.abrupt("return", new Promise(function (resolve) {
                  var lockName = "lock:".concat(name);

                  _this12._acquireLock(lockName, timeout, retryDelay, function (lockTimeoutValue) {
                    resolve(function () {
                      return __awaiter(_this12, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
                        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                          while (1) {
                            switch (_context15.prev = _context15.next) {
                              case 0:
                                if (!(lockTimeoutValue > Date.now())) {
                                  _context15.next = 2;
                                  break;
                                }

                                return _context15.abrupt("return", this["delete"]([lockName]));

                              case 2:
                              case "end":
                                return _context15.stop();
                            }
                          }
                        }, _callee15, this);
                      }));
                    });
                  });
                }));

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));
    }
    /**
     * Wraps a callback in a lock to ensure it is only run once at a time.
     * @param name the name of the lock
     * @param callback the code to execute
     * @param opts additional opts to pass to the lock function
     * @returns the return value of callback
     */

  }, {
    key: "runWithLock",
    value: function runWithLock(name, callback) {
      var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var releasePromise = _a.releasePromise,
          opts = __rest(_a, ["releasePromise"]);

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var unlock;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.lock(name, opts);

              case 2:
                unlock = _context17.sent;
                _context17.prev = 3;
                _context17.next = 6;
                return callback();

              case 6:
                return _context17.abrupt("return", _context17.sent);

              case 7:
                _context17.prev = 7;

                if (!releasePromise) {
                  _context17.next = 12;
                  break;
                }

                releasePromise["finally"](unlock);
                _context17.next = 14;
                break;

              case 12:
                _context17.next = 14;
                return unlock();

              case 14:
                return _context17.finish(7);

              case 15:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[3,, 7, 15]]);
      }));
    }
  }]);

  return CacheService;
}();

exports.CacheService = CacheService;